import { ActionReducer } from '@ngrx/store';

import { Actions, ActionTypes } from './applicationsettings.actions';
import { ApplicationSettingsInterface as ApplicationSettings } from './applicationsettings.models';
import { tassign } from '../../tools';

/**
 * Please do not modify the store directly. Always use reducers.
 */

export const initialApplicationSettingsState: ApplicationSettings = {
	items: [],
	isLoading: false
};

/**
 * Reduce the store.
 * @param {ApplicationSettings} state - the current state
 * @return {ApplicationSettings} The new state
 */
export const applicationsettings: ActionReducer<any, Actions> = (state: ApplicationSettings = initialApplicationSettingsState, action: Actions): ApplicationSettings => {
	switch (action.type) {

		case ActionTypes.LOAD_APPLICATION_SETTINGS:
			return action.payload;

		case ActionTypes.RESET_STATE:
			return initialApplicationSettingsState;

		case ActionTypes.SET_IS_LOADING:
			return tassign(state, {
				isLoading: action.payload
			});
	}
	return state;
};
